class MediaMatcher {
  MediaMatcherItems = [];

  addMediaQuery(mqlString, trueCallback = false, falseCallback = false) {
    const mqlObject = {
      mql: window.matchMedia(mqlString),
      string: mqlString,
      lastCheck: null,
      trueCallback,
      falseCallback,
    };

    this.MediaMatcherItems.push(mqlObject);

    return mqlObject;
  }

  clearQueries() {
    this.MediaMatcherItems = [];
  }

  triggerMqlObject(mqlObject) {
    const queryMatches = mqlObject.mql.matches;
    if (queryMatches && mqlObject.lastCheck !== true) {
      mqlObject.lastCheck = queryMatches;
      if (typeof mqlObject.trueCallback === 'function') mqlObject.trueCallback(mqlObject);
    } else if (!queryMatches && mqlObject.lastCheck !== false) {
      mqlObject.lastCheck = queryMatches;
      if (typeof mqlObject.falseCallback === 'function') mqlObject.falseCallback(mqlObject);
    }
  }

  findAndTriggerMqlObject(event) {
    this.MediaMatcherItems.forEach((mqlObject) => {
      if (event.media === mqlObject.string) this.triggerMqlObject(mqlObject);
    });
  }

  handleMediaChange = (event) => {
    this.findAndTriggerMqlObject(event);
  }

  evaluateAll = () => {
    this.MediaMatcherItems.forEach((mqlObject) => {
      this.triggerMqlObject(mqlObject);
    });
  }

  addListeners() {
    this.MediaMatcherItems.forEach((mqlObject) => {
      if (typeof mqlObject.mql.addEventListener !== 'undefined') {
        mqlObject.mql.addEventListener('change', this.handleMediaChange);
      } else {
        mqlObject.mql.addListener(this.handleMediaChange);
      }
    });
  }

  removeListeners() {
    this.MediaMatcherItems.forEach((mqlObject) => {
      if (typeof mqlObject.mql.removeEventListener !== 'undefined') {
        mqlObject.mql.removeEventListener('change', this.handleMediaChange);
      } else {
        mqlObject.mql.removeListener(this.handleMediaChange);
      }
    });
  }
}

export default MediaMatcher;
